import { TableBody, TableCell, TableRow, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export default function TableNotFound() {
	const { translate } = useLocales();
	return (
		<TableBody>
			<TableRow>
				<TableCell align='center' colSpan={12} sx={{ height: 500 }}>
					<Typography color='text.primary' sx={{ mb: 1 }} variant='h6'>
						{translate("result_demo.empty_table")}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	);
}
